import { Injectable } from '@angular/core';
import { GridConfig } from '../models/grid-config.model';
import { USER_GRID_CONFIG_DEFAULT, USER_GRID_STORAGE_KEY } from '../const/user.const';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GridConfigApi {
  private _gridConfig$ = new BehaviorSubject<GridConfig>(null);

  public get gridConfig$(): Observable<GridConfig> {
    return this._gridConfig$.asObservable();
  }

  getGridConfig(): GridConfig {
    const gridConfig = localStorage.getItem(USER_GRID_STORAGE_KEY);
    const result = gridConfig ? JSON.parse(gridConfig) : USER_GRID_CONFIG_DEFAULT;
    this._gridConfig$.next(result);
    return result;
  }

  setGridConfig(gridConfig: GridConfig): GridConfig {
    localStorage.setItem(USER_GRID_STORAGE_KEY, JSON.stringify(gridConfig));
    this._gridConfig$.next(gridConfig);
    return this.getGridConfig();
  }
}
